import { RealTimeAction } from '@/_core/fluxstore/types';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';
import { useSendCommand } from '@/_core/cqrs/use';
import { ChangeStorymapCardDefaultColors } from '../../../api/commands';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class ChangeSubtaskColor extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'ChangeSubtaskColor';

    public constructor(public color: number) {
        super(ChangeSubtaskColor.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: ChangeSubtaskColor): Promise<boolean> => {
    useSendCommand(action, {
        createCommand: () => new ChangeStorymapCardDefaultColors(state.id, state.activityColor, state.taskColor, action.color),
    });

    return true;
};

const reducer = (state: StorymapState, action: ChangeSubtaskColor): void => {
    state.subtaskColor = action.color;
};

//@ts-ignore
registerMiddleware(ChangeSubtaskColor.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(ChangeSubtaskColor.ACTION_TYPE, reducer);
